module.exports = __webpack_public_path__ + "img/img_yt_brand@3x.32255212.png";